<!-- Player Lookup Modal -->
@if (isVisible()) {
  <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 9999;">
    <!-- Backdrop -->
    <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.7);" (click)="closeModal()"></div>
    <!-- Modal Content -->
    <div style="position: relative; display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 20px;">
      <div style="background: white; border-radius: 4px; box-shadow: 0 5px 15px rgba(0,0,0,0.5); width: 100%; max-width: 900px; max-height: 90vh; display: flex; flex-direction: column;">
        <div style="padding: 15px 20px; border-bottom: 1px solid #e5e6e7; background-color: #f8f8f9; display: flex; justify-content: space-between; align-items: center;">
          <h4 style="margin: 0; font-size: 18px; font-weight: 600; color: #676a6c;">Find Existing Player</h4>
          <button type="button" style="background: none; border: none; font-size: 24px; cursor: pointer; color: #676a6c;" (click)="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div style="padding: 20px; overflow-y: auto; flex: 1;">
          <div style="margin-bottom: 20px;">
            <div style="display: flex; border: 1px solid #e5e6e7; border-radius: 1px;">
              <input
                #searchInput
                type="text"
                style="flex: 1; padding: 6px 12px; border: none; font-size: 14px; outline: none;"
                placeholder="Search by name, LPGA ID, or WWGR ID"
                [ngModel]="searchTerm()"
                (ngModelChange)="searchTerm.set($event)"
                />
                <span style="padding: 6px 12px; background-color: #ffffff; border-left: 1px solid #e5e6e7; display: flex; align-items: center;">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </div>
            @if (isLoading()) {
              <div style="text-align: center; padding: 30px;">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
                <p style="margin-top: 10px;">Loading players...</p>
              </div>
            }
            @if (!isLoading()) {
              <div style="max-height: 400px; overflow-y: auto; border: 1px solid #e7eaec; border-radius: 3px;">
                <table class="table table-striped table-hover" style="margin: 0; width: 100%;">
                  <thead style="background-color: #f8f8f9;">
                    <tr>
                      <th style="padding: 8px;">
                        <app-sortable-header column="lastName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                          Last Name
                        </app-sortable-header>
                      </th>
                      <th style="padding: 8px;">
                        <app-sortable-header column="firstName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                          First Name
                        </app-sortable-header>
                      </th>
                      <th style="padding: 8px;">
                        <app-sortable-header column="shortName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                          Short Name
                        </app-sortable-header>
                      </th>
                      <th style="padding: 8px;">
                        <app-sortable-header column="lpgaId" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                          LPGA ID
                        </app-sortable-header>
                      </th>
                      <th style="padding: 8px;">
                        <app-sortable-header column="wwgrId" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                          WWGR ID
                        </app-sortable-header>
                      </th>
                      <th style="padding: 8px;">
                        <app-sortable-header column="countryName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                          Country
                        </app-sortable-header>
                      </th>
                      <th style="padding: 8px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (filteredPlayers().length === 0) {
                      <tr>
                        <td colspan="7" style="text-align: center; padding: 20px; color: #999;">
                          @if (searchTerm()) {
                            <span>No players found matching "{{ searchTerm() }}"</span>
                          }
                          @if (!searchTerm()) {
                            <span>No players available</span>
                          }
                        </td>
                      </tr>
                    }
                    @for (player of filteredPlayers(); track trackByPlayerId($index, player)) {
                      <tr style="cursor: pointer;">
                        <td style="padding: 8px;">{{ player.lastName }}</td>
                        <td style="padding: 8px;">{{ player.firstName }}</td>
                        <td style="padding: 8px;">{{ player.shortName }}</td>
                        <td style="padding: 8px;">{{ player.lpgaId }}</td>
                        <td style="padding: 8px;">{{ player.wwgrId }}</td>
                        <td style="padding: 8px;">{{ player.countryName }}</td>
                        <td style="padding: 8px;">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="selectPlayer(player)"
                            title="Select this player"
                            >
                            <i class="fa fa-check"></i> Select
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
          <div style="padding: 15px 20px; border-top: 1px solid #e5e6e7; background-color: #f8f8f9; text-align: right;">
            <button type="button" class="btn btn-white" (click)="closeModal()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  }
